import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { BetweenDates } from "../Betweendates";

export default function BirthDate() {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  
  return (
    <>
      <fieldset>
        <legend>{t("Birth date")}</legend>
        <BetweenDates
          setObeject={setSearchObject}
          dateObject={searchObject}
          dateEndField="birthDateEnd"
          dateStartField="birthDateStart"
        />
      </fieldset>
    </>
  );
}
